// extracted by mini-css-extract-plugin
export var avatarContainer = "_3s-1";
export var largeAvatarContainer = "_3s-2";
export var smallAvatarContainer = "_3s-0";